const state = {
    itens: [],
    item: {
        administrate_tax: 0,
        administrator_id: null,
        administrator: {
            id: null,
            name: 'Não definida',
            commissions : []
        },
        client_id: null,
        client: {
            id: null,
            name: 'Não definido',
            cpf_cnpj: '',
            registration_number: '',
            dispatcher_registration_number: '',
            shipment_date_registration_number: new Date(),
            date_of_birth: new Date(),
            nationality: '',
            profession: '',
            marital_status: 'S',
            sex: 'M',
            authorize_disseminate_data: false,
            mail: null,
            cell_phone: null,
            home_phone: null,
            commercial_phone: null,
            bank: {
                id: null,
                name: 'Não definido'
            },
            bank_branch: 0,
            bank_digit_branch: 0,
            account_number: 0,
            account_digit: 0
        },
        client_address: {
            cep: '',
            address: '',
            number: '',
            borough: '',
            complement: '',
            city: {
                id: null,
                name: 'Não definido',
                state: {
                    id: null,
                    name: 'Não definido',
                    abbreviation: 'ND'
                }
            }
        },
        condition: 'Não definido',
        contemplate_at: null,
        paid_billet: false,
        type_contemplation: null,
        documents: [],
        evaluate_at: null,
        formation: 'Não definido',
        fuel: {
            id: null,
            name: 'Não definido'
        },
        group_id: null,
        group: {
            id: null,
            name: 'Não definido'
        },
        id: 0,
        invoice_at: null,
        installments: [
            {
                id: null,
                order: 1,
                commision: 0,
                contacted: false,
                due_at: new Date(),
                pay_at: null,
                price: 0,
            }
        ],
        life_insurance: 0,
        medias: 'Não definido',
        meeting_at: new Date(),
        first_meeting_at: new Date(),
        model_id: null,
        model: {
            id: null,
            name: 'Não definido',
            manufacturer_id: null,
            manufacturer: {
                id: null,
                name: 'Não definido'
            }
        },
        number_installments: 0,
        observations: '',
        option_plan: null,
        physical_proposal: '00000',
        plan: {
            id: null,
            name: 'Não definido-'
        },
        plot_amount: 0,
        proposal_payments: [
            {
                id: null,
                name: 'Não definido'
            }
        ],
        proposal_status_id: null,
        proposal_status: {
            id: null,
            name: 'Não definido'
        },
        quota: 0,
        reason_acquisition: 'Não definido',
        reserve_fund: 0,
        sale_at: new Date(),
        deployment_at: new Date(),
        salesman: {
            id: null,
            name: 'Não definido'
        },
        type_group_id: 1,
        type_group: {
            id: null,
            name: 'Não definido'
        },
        value: 0,
        type_sale :{
            id : null,
            name : 'Não definido'
        },
        user_indicator : {
            id : null,
            name : 'Não possui'
        },
        protocol : null,
        vehicle_is_new: false,
        disposal_fee_is_internal: false
    },
    printable: ''
};

export default state;